// import banner1 from '../../assets/pullmanSanAndres/slide1.jpg';
// import banner2 from '../../assets/pullmanSanAndres/slide2.jpg';
// import banner3 from '../../assets/pullmanSanAndres/slide3.jpg';
// import banner4 from '../../assets/pullmanSanAndres/slide4.jpg';
// import banner5 from '../../assets/pullmanSanAndres/slide5.jpg';
// import banner6 from '../../assets/pullmanSanAndres/slide6.jpg';

// import banner1 from '../../assets/pullmanSanAndres/PullmanSanAndres-Slide-1.jpg';
// import banner2 from '../../assets/pullmanSanAndres/PullmanSanAndres-Slide-1.jpg';

import company1 from '../../assets/pullmanSanAndres/company1.png';
import company2 from '../../assets/pullmanSanAndres/company2.png';
import company3 from '../../assets/pullmanSanAndres/company3.png';
import company4 from '../../assets/pullmanSanAndres/company4.png';
import company5 from '../../assets/pullmanSanAndres/company5.png';
import homeSliders1 from '../../assets/pullmanSanAndres/arica.png';
import homeSliders2 from '../../assets/pullmanSanAndres/iquique.png';
import homeSliders3 from '../../assets/pullmanSanAndres/antofagasta.png';
import homeSliders5 from '../../assets/pullmanSanAndres/santiago.png';

const homeSliders4 = '/assets/pullmanSanAndres/calamaa.png';
const homeSliders6 = '/assets/pullmanSanAndres/PullmanSanAndres-Destinations-Copiapo.png';

const banner1 = '/assets/pullmanSanAndres/PullmanSanAndres-Slide-1.jpg';
const banner2 = '/assets/pullmanSanAndres/PullmanSanAndres-Slide-3.png';
const banner3 = '/assets/pullmanSanAndres/andres1.png';
const banner = [
  // banner1,
  // banner2,
  // banner6,
  // banner3,
  // banner4,
  // banner5,
		banner3,
  banner1,
  banner2,
	
];
const companySlides = [
  { banner: company1, text: '' },
  { banner: company2, text: '' },
  { banner: company3, text: '' },
  { banner: company4, text: '' },
  { banner: company5, text: '' },
];
const homeSliders = [
  { banner: homeSliders1, text: 'Arica' },
  { banner: homeSliders2, text: 'Iquique' },
  { banner: homeSliders3, text: 'Antofagasta' },
  { banner: homeSliders4, text: 'Calama' },
  { banner: homeSliders5, text: 'Santiago' },
  { banner: homeSliders6, text: 'Copiapó' },
];

const pullmansanandresSlides = {
  banner,
  homeSliders,
  companySlides,
};

export default pullmansanandresSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/pullmanSanAndreas.js